// extracted by mini-css-extract-plugin
module.exports = {"page_header":"_ykFcAgqs"};